/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Addweekdays1Inputs */

const en_addweekdays1 = /** @type {(inputs: Addweekdays1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add Weekdays (${i?.count})`)
};

const de_addweekdays1 = /** @type {(inputs: Addweekdays1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wochentage hinzufügen (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Add Weekdays ({count})" |
*
* @param {Addweekdays1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const addweekdays1 = /** @type {((inputs: Addweekdays1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addweekdays1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addweekdays1(inputs)
	return de_addweekdays1(inputs)
});
export { addweekdays1 as "addWeekdays" }